import { CdkDragDrop, DragDropModule, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { Graph } from '@iot-platform/models/common';
import { WidgetEvent, WidgetInstance, WidgetSize } from '@iot-platform/models/widgets';
import { WidgetItemComponent } from '../widget-item/widget-item.component';

@Component({
  imports: [FlexLayoutModule, WidgetItemComponent, DragDropModule],
  selector: 'iot-platform-ui-widgets-container',
  templateUrl: './widgets-container.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./widgets-container.component.scss']
})
export class WidgetsContainerComponent {
  enableDragAndDrop = input<boolean>(false);
  widgets = input<WidgetInstance[], WidgetInstance[]>([], {
    transform: (value: WidgetInstance[]) => value?.slice()?.sort((widgetA, widgetB) => widgetA.data.displayOrder - widgetB.data.displayOrder)
  });

  dispatchEvent = output<WidgetEvent>();
  widgetsOrderChange = output<WidgetInstance[]>();

  drop(event: CdkDragDrop<WidgetInstance[]>) {
    moveItemInArray(this.widgets(), event.previousIndex, event.currentIndex);
    const reorderedWidgets = this.getReorderedWidgets(this.widgets());
    if (reorderedWidgets.length) {
      this.widgetsOrderChange.emit(reorderedWidgets);
    }
  }

  getReorderedWidgets(widgets: WidgetInstance[]): WidgetInstance[] {
    return widgets.reduce((acc: WidgetInstance[], widget: WidgetInstance, currentIndex) => {
      if ((widget.data as Graph).displayOrder !== currentIndex) {
        (widget.data as Graph).displayOrder = currentIndex;
        acc.push(widget);
      }
      return acc;
    }, []);
  }

  protected readonly WidgetSize = WidgetSize;
}
